import React from 'react';

export const OkIcon: React.FC = () => (
	<svg width='2rem' height='2rem' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
		<circle cx='10' cy='10' r='9' stroke='#003D81' strokeWidth='2' />
		<path d='M5.71484 9.88092L8.57199 12.7381L14.1672 7.14282' stroke='#41B6E6' strokeWidth='2' />
	</svg>
);
